import { Big } from 'big.js';

export const BIG_ONE = new Big(1);

export function toBig(value: any): Big {
    if (value === null || value === undefined || value === '') {
        return new Big(0);
    }
    if (typeof value === 'object' && value.value !== undefined) {
        return toBig(value.value);
    }
    return new Big(value);
}
